module.exports = __webpack_public_path__ + "static/media/spin.3781500a.gif";